import * as React from 'react';
// import BubbleGroupInterface from './interface';
import {ChatBubble as DefaultChatBubble, Message} from 'react-chat-ui';
import styles from './styles';

export default class BubbleGroup extends React.Component {
  props: any;

  /**
   * Parses and collects messages of one type to be grouped together.
   * @return {messageNodes} - a JSX wrapped group of messages
   */
  renderGroup(messages: [Message], id: number) {
    const {
      bubblesCentered,
      bubbleStyles,
      showSenderName,
      chatBubble,
      senderName,
      mode,
    } = this.props;
    const ChatBubble = chatBubble || DefaultChatBubble;
    const sampleMessage = messages[0];

    const messageNodes = messages.map((message, i) => {
      return (
        <ChatBubble
          key={i}
          mode={mode}
          message={message}
          bubblesCentered={bubblesCentered}
          bubbleStyles={bubbleStyles}
        />
      );
    });

    // @ts-ignore
    return (<div style={styles.chatbubbleWrapper}>
        {showSenderName &&
          ((senderName || sampleMessage.senderName) !== '' &&
            (sampleMessage.id !== 0
            // @ts-ignore
            && (<h5 style={styles.bubbleGroupHeader}>
                {senderName || sampleMessage.senderName}
              </h5>
            )))}
        {messageNodes}
      </div>
    );
  }

  render() {
    const { messages, id } = this.props;
    return this.renderGroup(messages, id);
  }
}
